import { makeStyles } from '@material-ui/core';
import * as colours from 'colours';

const commonTextOptions = {
  fontFamily: "'Ubuntu', 'Arial', 'Helvetica', sans-serif",
  fontWeight: 400,
  fontSize: '14px',
};

export const useFooterMenuStyles = makeStyles((theme) => ({
  box: {
    padding: '10px 30px',
    backgroundColor: colours.WHITE,
    borderTop: '1px solid #d6d6d6',
    borderBottom: '1px solid #d6d6d6',
  },
  svgImage: {
    maxHeight: '80px',
    maxWidth: '230px',
  },
  primaryText: {
    ...commonTextOptions,
    fontWeight: '700',
    fontSize: '10px',
    lineHeight: '14px',
    color: colours.FOOTER_TEXT_PRIMARY,
  },
  secondaryText: {
    ...commonTextOptions,
    fontWeight: '700',
    fontSize: '10px',
    lineHeight: '14px',
    color: colours.FOOTER_TEXT_PRIMARY,
  },
}));
